











































import { Vue, Component } from 'vue-property-decorator';
import { companyServer } from '@/api/installServer';
import dayjs from 'dayjs';
import { TableStripe } from '@/mixins/tableStripe';
import PagingUnit from '@/components/paging/paging.vue';

@Component({
  components: { PagingUnit },
  mixins: [TableStripe],
})
export default class SafetyMonitoring extends Vue {
  private companyList: any = [];
  private filterForm: any = {};

  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0;
  loadingTable = false;
  tableData: any = [];

  created() {
    const nowDate: any = new Date();
    const stateDate: any = dayjs().format('YYYY-MM-DD');
    const preDate: any = dayjs(new Date(nowDate.getTime() - 24 * 60 * 60 * 1000 * 7)).format('YYYY-MM-DD');
    this.getCompanyList();
    this.getList();
  }
  getListData() {
    this.getList();
  }
  private getList() {}
  getCompanyList() {
    companyServer
      .getCompanySelectList({
        companyPlaceType: 'COMPANY',
      })
      .then((res: any) => {
        this.companyList = res.data;
      });
  }

  mounted() {}
  searchForm() {}
  resetForm() {}
}
